<template>
  <div class="share-btn" @click="click" :class="{mini: isMini}">
    <div v-show="!isMini">
      <div class="cap">画像&amp;カラーセットをツイート</div>
      <div class="info">次の画面でツイートする内容を確認できます</div>
      <div class="minimize" @click.stop="minimize"></div>
    </div>
  </div>
</template>

<style scoped>
.share-btn {
  text-align: center;
  background: #00000080;
  border: 1px solid #ffffff80;
  border-radius: 8px;
  color: white;
  background-position: 0px 0px;
  background-size: 40px;
  background-repeat: no-repeat;
  width: 280px;
  right: calc(50% - 140px);
  bottom: 10px;
  transition:
    all 350ms 0.05s cubic-bezier(.41,.8,.67,1)
  ;
  box-shadow: 3px 3px 12px 0px rgba(0,0,0,0.75);
}
.share-btn.mini {
  width: 50px;
  height: 30px;
  right: -20px;
  bottom: 20px;
  text-align: left;
  padding-left: 12px;
  border-radius: 15px;
  background-image: url(/static/tweet.png);
  background-repeat: no-repeat;
  background-position: 5px 2px;
  background-size: 24px;
}
.cap {
  font-size: 12pt;
  font-weight: bold;
  text-decoration: underline;
}
.info {
  font-size: 9pt;
}
.minimize {
  width: 30px;
  height: 30px;
  top: 0px;
  left: -10px;
  position: absolute;
  transform-origin: 50%;
  transform: rotate(45deg)
}
.minimize::before {
  content: ' ';
  position: absolute;
  width: 13px;
  height: 3px;
  top: 5px;
  border-top: 3px solid white;
}
.minimize::after {
  content: ' ';
  position: absolute;
  width: 3px;
  height: 13px;
  left: 20px;
  border-left: 3px solid white;
}
</style>

<script>
export default {
  name: 'StockShareBtn',
  data () {
    return {
      isMini: false
    }
  },
  methods: {
    click () {
      if (this.isMini) {
        this.maximize()
      } else {
        this.$emit('click')
      }
    },
    minimize () {
      this.isMini = true
    },
    maximize () {
      this.isMini = false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/StockShareBtn.vue